// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._DLqc2MYjDwGmxrSSS5Y {
  display: flex;
  width: 100%;
  gap: 20px;
  padding-left: 40px;
}
._DLqc2MYjDwGmxrSSS5Y > div {
  width: 32%;
  min-width: 0;
}

.LKCATg4PVyHvKpm9xOQu {
  display: flex;
  gap: 4px;
  white-space: nowrap;
  width: 100%;
  min-width: 0;
}

.TxoE5UQPxzthAFQLEJhN {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #dedede;
  border-radius: 0 0 6px 6px;
  padding: 10px 0 10px 20px;
}

.VgSpqXEnjokDRjYaEU8Q {
  width: 34%;
  padding: 0 10px;
}

.V5FN31dVm3DAcO33dopX {
  width: 33%;
  padding-right: 10px;
}

.aQqTgcU6AVSdpKjpjLAw {
  height: auto;
}

.gLHk_GiP9JDkSZArxoyc {
  white-space: nowrap;
  width: 33%;
  padding-right: 10px;
}

.gUFOkfIoUTDBvfXCyQjm {
  list-style-type: disc;
  padding-left: 20px;
}
.gUFOkfIoUTDBvfXCyQjm > li {
  padding-bottom: 2px;
}

.Y_oSagEHD04DByrDsHG6 {
  margin-bottom: 25px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/sources/sources.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAAF;AAEE;EACE,UAAA;EACA,YAAA;AAAJ;;AAIA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;AADF;;AAIA;EACE,UAAA;EACA,eAAA;AADF;;AAIA;EACE,UAAA;EACA,mBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,mBAAA;EACA,UAAA;EACA,mBAAA;AADF;;AAIA;EACE,qBAAA;EACA,kBAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,mBAAA;AAFF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.upload_title_wrapper {\n  display: flex;\n  width: 100%;\n  gap: 20px;\n  padding-left: 40px;\n\n  > div {\n    width: 32%;\n    min-width: 0;\n  }\n}\n\n.upload_title_segment {\n  display: flex;\n  gap: 4px;\n  white-space: nowrap;\n  width: 100%;\n  min-width: 0;\n}\n\n.upload_body {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  border: 1px solid $border-color-default;\n  border-radius: 0 0 6px 6px;\n  padding: 10px 0 10px 20px;\n}\n\n.upload_body__left_column {\n  width: 34%;\n  padding: 0 10px;\n}\n\n.upload_body__middle_column {\n  width: 33%;\n  padding-right: 10px;\n}\n\n.upload_body__divider {\n  height: auto;\n}\n\n.upload_body__right_column {\n  white-space: nowrap;\n  width: 33%;\n  padding-right: 10px;\n}\n\n.upload_body__additional_data_list {\n  list-style-type: disc;\n  padding-left: 20px;\n\n  > li {\n    padding-bottom: 2px;\n  }\n}\n\n.relationships_section {\n  margin-bottom: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upload_title_wrapper": `_DLqc2MYjDwGmxrSSS5Y`,
	"upload_title_segment": `LKCATg4PVyHvKpm9xOQu`,
	"upload_body": `TxoE5UQPxzthAFQLEJhN`,
	"upload_body__left_column": `VgSpqXEnjokDRjYaEU8Q`,
	"upload_body__middle_column": `V5FN31dVm3DAcO33dopX`,
	"upload_body__divider": `aQqTgcU6AVSdpKjpjLAw`,
	"upload_body__right_column": `gLHk_GiP9JDkSZArxoyc`,
	"upload_body__additional_data_list": `gUFOkfIoUTDBvfXCyQjm`,
	"relationships_section": `Y_oSagEHD04DByrDsHG6`
};
export default ___CSS_LOADER_EXPORT___;
